import { render, staticRenderFns } from "./ResendForm.vue?vue&type=template&id=394b1973&scoped=true&"
import script from "./ResendForm.vue?vue&type=script&lang=ts&"
export * from "./ResendForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394b1973",
  null
  
)

export default component.exports